module.exports = __webpack_public_path__ + "media/images/hierarchy-de7a2237.png";